import React, {Component} from "react";
import FakturJualSearch from "../common/fakturJualSearch";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import {getValueFromDDL, mapToObjectDDL, removeNullFields} from "../../../../common/mapper";
import Moment from "moment/moment";
import Api from "../../../../../Services/Api";
import ErrorAction from "../../../../../Redux/ErrorRedux";
import {connect} from "react-redux";
import {fetchDataAsync, getUserAccess} from "../../../../../Services/Utils";
import {ACTIVITY_TYPE, HttpStatus} from "../../../../common/Constants";
import {defaultTableChange} from "../../../../../modules/custom/customTable";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import {config} from "./config";
import FakturJualNOSFilter from "./fakturJualNOSFilter";
import FlexView from "react-flexview";
import FakturJualDetail from "../common/fakturJualDetail";
import {formGroup} from "../config";
import * as R from "ramda";
import SimpleModal from "../../../../../modules/popup/SimpleModal";
import {reportType} from "../../../payment/transaksiCash/tabBKM/config";
import {service} from "../service";
import SimpleAlert from "../../../../../modules/popup/SimpleAlert";

class FakturJualNOS extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            filterVisible: false,
            detailVisible: false,
            printPreviewVisible: false,
            selectedData: null,
            selectedIndex: null,
            kodeCabang: null,
            submittedFilterData: {},
            filterData: {},
            searchData: {
                startFJDate: Moment().format("DD-MM-yyyy"),
                endFJDate: Moment().format("DD-MM-yyyy"),
            },
            skipNextPaginationFetch: false,
            PDF: null,
            cabangOptions: [],
            tableColumns: this.getTableColumns(),
            dataTable: [],
            pagination: {
                totalData: 1,
                page: 1,
                limit: 5,
            },
            changeCabang: false,
            printVisible: false,
            userAccess: null,
            activityType: null,
            alertInfo:{
              visible: false,
              title: null,
              content: null
            },
        };
    }

    getTableColumns() {
        let columns = [...config.tableColumns];
        columns.push({
            name: "salesOrderState",
            label: "Aksi",
            options: {
                customBodyRender: (val, tableMeta) => {
                    const isDisabledMelengkapi = this.state.userAccess.createAccess ? val !== "FJ_DRAFT" || val === "FJ_CANCEL" : !this.state.userAccess.createAccess
                    let isDisabledUpdate;
                    if (this.state.userAccess.updateAccess) {
                      const disabledStatuses = [
                      "FJ_DRAFT",
                      "FJ_CANCEL",
                      "FJ_DELETED",
                      "SSU_RECEIVING",
                      "SAMSAT_BIRO_SUBMIT",
                      "SAMSAT_TAXNOTE_RECEIVING",
                      "SAMSAT_STNK_RECEIVING",
                      "SAMSAT_PLAT_RECEIVING",
                      "SAMSAT_BPKB_RECEIVING",
                      "BBN_TAXNOTE_HANDOVER",
                      "BBN_STNK_HANDOVER",
                      "BBN_PLAT_HANDOVER",
                      "BBN_BPKB_HANDOVER"
                    ];
                      isDisabledUpdate = disabledStatuses.includes(val);
                    } else {
                        isDisabledUpdate = !this.state.userAccess.updateAccess;
                    }
                    return (
                        <FlexView hAlignContent="center" style={{gap: 10}}>
                            <SimpleButton
                                type="button"
                                category="action_button"
                                icon={<i style={{fontSize: 20, color:"red"}} className="fa fa-lg fa-eye"/>}
                                onClick={() => this.handleShowDetail(tableMeta.rowIndex, false)}
                            />
                            <SimpleButton
                              id="btn_melengkapi"
                              category="action_button"
                              type="button"
                              disabled={isDisabledMelengkapi}
                              styles={{ width: "unset" }}
                              icon={<i className={`fa fa-lg fa-file ${isDisabledMelengkapi ? "color-grey": "color-red"}`} />}
                              onClick={() => this.handleShowDetail(tableMeta.rowIndex, true, ACTIVITY_TYPE.CORRECTION)}
                            />
                            <SimpleButton
                                type="button"
                                disabled={isDisabledUpdate}
                                category="action_button"
                                icon={<i style={{fontSize: 20}} className={`fa fa-lw fa-pencil-alt ${isDisabledUpdate ? "color-grey": "color-red"}`}/>}
                                onClick={() => this.handleShowDetail(tableMeta.rowIndex, true, ACTIVITY_TYPE.UPDATE)}
                            />
                            <SimpleButton
                                type="button"
                                category="action_button"
                                icon={<i style={{fontSize: 20, color:"red"}} className="fa fa-lg fa-print"/>}
                                onClick={() => this.handlePrintVisibility(tableMeta.rowIndex)}
                            />
                        </FlexView>
                    )
                },
                sort: false
            },
        })

        return columns;
    }

    componentDidMount = async () => {
        this.handleTriggerLoading();
        let kodeCabang = null;
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang,
            setError: this.props.setError,
            menuName: "Sales Order - Faktur Jual",
            args: {},
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            let filteredData = res.data.data.filter(
                item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
            );
            if (filteredData.length !== 0) {
                kodeCabang = mapToObjectDDL(filteredData[0].namaDealer, filteredData[0].kodeCabang);
                this.setState((prevValue) => ({
                    ...prevValue,
                    cabangOptions: filteredData.map(item => mapToObjectDDL(item.namaDealer, item.kodeCabang)),
                    kodeCabang: kodeCabang,
                    userAccess: getUserAccess(this.props.menuAccess, kodeCabang.value)
                }));
            }
        }
        await this.fetchData({
            kodeCabang: kodeCabang?.value,
            ...this.state.searchData,
        });
        this.setState({
          submittedFilterData: {
            kodeCabang: kodeCabang?.value,
            ...this.state.searchData,
          },
        });
        this.handleTriggerLoading();
    }

    componentDidUpdate = async (_, prevState) => {
        if (
            (prevState.pagination.page !== this.state.pagination.page ||
                prevState.pagination.limit !== this.state.pagination.limit) &&
            !this.state.changeCabang && !this.state.skipNextPaginationFetch
        ) {
            this.handleTriggerLoading();
            await this.fetchData(
                this.state.submittedFilterData,
                this.state.pagination.page,
                this.state.pagination.limit
            );
            this.handleTriggerLoading();
        }
        if(this.state.skipNextPaginationFetch){
            this.setState({ skipNextPaginationFetch: false });
        }
    }

    fetchData = async (filter = {}, page = 1, limit = 5) => {
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").getListSalesOrderNOS,
            setError: this.props.setError,
            menuName: "Faktur Jual - NOS",
            args: {...filter, page, limit},
        });

        if (res.ok && res.data.status === HttpStatus.SUCCESS) {
            this.setState((prevValue) => ({
                ...prevValue,
                changeCabang: false,
                dataTable: !R.isEmpty(res.data.data) ? res.data.data : [],
                pagination: {
                    ...prevValue.pagination,
                    totalData: res.data.totalData,
                },
            }));
        }
    };

    handleShowDetail = (index, isEditable, activityType) => {
        this.setState((prevValue) => ({
            ...prevValue,
            detailVisible: !prevValue.detailVisible,
            selectedData: this.state.dataTable[index],
            isEditable: isEditable,
            activityType: activityType || null,
        }));
    };

    handleModalFilterVisibility = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: !prevValue.filterVisible,
        }));
    };

    handleStateChange = (callback) => {
        this.setState(callback);
    };

    handleSubmitFilter = async () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: true,
            searchData: {},
        }));
        this.setState({ skipNextPaginationFetch: true });
        this.handleResetPagination()

        const request = removeNullFields({
            ...this.state.filterData,
            kodeCabang: this.state.kodeCabang.value,
            kodeVariant: getValueFromDDL(this.state.filterData, "kodeVariant"),
            idWarna: getValueFromDDL(this.state.filterData, "idWarna"),
            orderState: getValueFromDDL(this.state.filterData, "orderState"),
        });

        await this.fetchData(request, 1, this.state.pagination.limit);
        this.setState((prevValue) => ({
            ...prevValue,
            filterVisible: false,
            submittedFilterData: request,
            loading: false,
        }));
    };

    handleValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            searchData: {
                ...prevValue.searchData,
                [name]: value,
            },
        }));
    };

    handleCabangChange = async (name, value) => {
        this.handleTriggerLoading();
        console.log(name, value.value)
        this.setState((prevValue) => ({
          ...prevValue,
          [name]: value,
          searchData: {
            startFJDate: Moment().format("DD-MM-yyyy"),
            endFJDate: Moment().format("DD-MM-yyyy"),
          },
          filterData: {},
          submittedFilterData: {
            kodeCabang: value.value,
            startFJDate: Moment().format("DD-MM-yyyy"),
            endFJDate: Moment().format("DD-MM-yyyy"),
          },
          pagination: {
            totalData: 0,
            page: 1,
            limit: 5,
          },
          changeCabang: true,
          userAccess: getUserAccess(this.props.menuAccess, value.value),
        }));
        await this.fetchData(
            {
                kodeCabang: value.value,
                startFJDate: Moment().format("DD-MM-yyyy"),
                endFJDate: Moment().format("DD-MM-yyyy"),
            }
        );
        this.handleTriggerLoading();
    };

    handleClickSearch = async () => {
        this.setState((prevValue) => ({
          ...prevValue,
          loading: true,
          filterData: {},
          skipNextPaginationFetch: true,
          pagination: {
            ...prevValue.pagination,
            page: 1,
          },
        }));

        const {startFJDate, endFJDate, key, value} = this.state.searchData || {};

        const request = removeNullFields({
            kodeCabang: this.state.kodeCabang?.value,
            startFJDate: startFJDate ? startFJDate : null,
            endFJDate: endFJDate ? endFJDate : null,
            ...(key && value ? {[key?.value]: value} : {})
        });

        await this.fetchData(request, 1, this.state.pagination.limit);

        this.setState((prevValue) => ({
            ...prevValue,
            submittedFilterData: request,
            loading: false,
        }));
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({
            ...prevValue,
            loading: !prevValue.loading,
        }));
    };

    handlePrint = async (action, type) => {
        this.handleTriggerLoading();
        const selectedData = this.state.dataTable[this.state.selectedIndex];
        let report = type === "SCP"
            ? selectedData.salesOrderState !== "FJ_CANCEL"
                ? reportType.SCP
                : reportType.SCP_CANCELED
            : selectedData.salesOrderState !== "FJ_CANCEL"
                ? reportType.FJ
                : reportType.FJ_CANCELED;
        let req = {
            salesOrderNo: selectedData.nomorFJ,
            reportType: report,
        }
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_REPORT").printSalesOrder,
            setError: this.props.setError,
            menuName: "Faktur Jual - NOS",
            args: req,
        });
        if (res.ok) {
            if (action === "preview") {
                this.setState((prevValue) => ({
                    ...prevValue,
                    printPreviewVisible: !prevValue.printPreviewVisible,
                    PDF: URL.createObjectURL(res.data),
                }));
            } else {
                let fileName = report + "_" + selectedData.nomorFJ;
                service.downloadPdf(res.data, fileName);
                // todo un comment after deploy print count services
                // await fetchDataAsync({
                //     asyncFn: Api.create("NAGAMAS_REPORT_DTO").updatePrintCount,
                //     menuName: "Faktur Jual - NOS",
                //     setError: this.props.setError,
                //     args: {
                //         refNumber: selectedData.nomorFJ,
                //         type: report,
                //     }
                // });
            }
        }
        this.handleTriggerLoading();
    }

    handlePrintPreviewVisibility = async (action, type) => {
        switch (action) {
            case "generate":
                await this.handlePrint("preview", type);
                break;
            case "close":
                this.setState((prevValue) => ({
                    ...prevValue,
                    printPreviewVisible: !prevValue.printPreviewVisible,
                    PDF: null,
                }));
                break;
            default:
                break;
        }
    }

    handlePrintVisibility = (index) => {
        this.setState((prevValue) => ({
            ...prevValue,
            printVisible: !prevValue.printVisible,
            selectedIndex: index,
        }));
    }

    handlePrintMainPage = async() => {
        this.handleTriggerLoading();
        const kodeCabang = this.state.kodeCabang?.value;
        let res = await fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION_FILE").printMainPageSalesOrderNos,
            setError:this.props.setError,
            menuName:"Faktur Jual - NOS",
            args: { kodeCabang }
        });

        if (res.ok) {
          const blob = new Blob([res.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"});
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = `Monitoring Faktur Jual NOS - ${kodeCabang}.xlsx`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        }
        this.handleTriggerLoading();
    }

    handleChangePage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                ...prevValue.pagination,
                page: tableState.page + 1,
            },
        }));
    };

    handleRowsPerPage = (tableState) => {
        this.setState((prevValue) => ({
            ...prevValue,
            pagination: {
                page: 1,
                totalData: 1,
                limit: tableState.rowsPerPage,
            },
        }));
    };

    handleSubmit = async (data) => {
        this.handleTriggerLoading();
        const res = await this.save(data);
        if(res.data.code === 406){
            this.handleTriggerLoading();
            return this.handleVisibleAlertInfo("Informasi", res.data.message)
        }
        this.handleShowDetail();
        this.setState((prev) => ({
          ...prev,
          skipNextPaginationFetch: true,
          searchData: {
            startFJDate: Moment().format("DD-MM-yyyy"),
            endFJDate: Moment().format("DD-MM-yyyy"),
          },
          filterData: {},
        }));
        this.handleResetPagination()
        await this.fetchData(
        this.state.submittedFilterData,
          this.state.pagination.page,
          this.state.pagination.limit
        );
        this.handleTriggerLoading();
    }

    save = async (requestBody) => {
        let {dataPackage, ...rest} = requestBody;
        let {selectedPackage, ...rest2} = dataPackage;
        return fetchDataAsync({
            asyncFn: Api.create("NAGAMAS_TRANSACTION").submitSalesOrder,
            setError: this.props.setError,
            menuName: "Faktur Jual - Sales Order",
            args: {
                ...rest,
                dataPackage: rest2,
            },
        })
    }

    handleReloadDetail = () =>{
        this.handleShowDetail();
        this.setState(
          (prev) => ({
            ...prev,
            skipNextPaginationFetch: true,
          }),
          () => {
            this.fetchData(
              {...this.state.submittedFilterData},
              this.state.pagination.page,
              this.state.pagination.limit
            );
          }
        );
    }

    handleResetPagination = () =>{
      this.setState((prev) => ({
        ...prev,
        pagination: {
          ...prev.pagination,
          page: 1,
          totalData: 0,
        },
      }));
    }

    handleVisibleAlertInfo = (title,content) =>{
      this.setState((prev) => ({
        ...prev,
        alertInfo: {
          ...prev.alertInfo,
          visible: !prev.alertInfo.visible,
          title: title,
          content: content
        },
      }));
    }

    render() {
        return (
            <>
                <FakturJualSearch
                    tab="NOS"
                    state={this.state}
                    onSubmit={this.handleClickSearch}
                    onShowFilter={this.handleModalFilterVisibility}
                    onValueChange={this.handleValueChange}
                    onCabangChange={this.handleCabangChange}
                    menuAccess={this.props.menuAccess}
                />
                <SimpleDataTable
                    data={this.state.dataTable}
                    columns={this.state.tableColumns}
                    toCount={this.state.pagination.totalData}
                    rowsPerPage={this.state.pagination.limit}
                    page={this.state.pagination.page - 1}
                    options={defaultTableChange(this.handleChangePage, this.handleRowsPerPage)}
                    footerAdditionalButtons={
                        <>
                            {this.state.userAccess?.createAccess &&
                                <SimpleButton
                                    text="Tambah Data"
                                    onClick={() => this.handleShowDetail(null, true)}
                                />
                            }
                            <SimpleButton
                                text="Cetak"
                                onClick={this.handlePrintMainPage}
                            />
                        </>
                    }
                />
                {this.state.filterVisible && (
                    <FakturJualNOSFilter
                        state={this.state}
                        onSetState={this.handleStateChange}
                        onClickClose={this.handleModalFilterVisibility}
                        onSubmit={this.handleSubmitFilter}
                    />
                )}
                {this.state.detailVisible && (
                    <FakturJualDetail
                        tab="NOS"
                        formGroup={formGroup}
                        state={this.state}
                        visible={this.state.detailVisible}
                        onSubmit={this.handleSubmit}
                        onClickClose={() => this.handleShowDetail()}
                        onReload={()=>this.handleReloadDetail()}
                    />
                )}
                {this.state.printVisible && (
                    <SimpleModal
                        title="Preview dan Cetak"
                        styles={{width: "40%"}}
                        visible={this.state.printVisible}
                        onClickClose={() => this.handlePrintVisibility(null)}
                        content={
                            <FlexView column style={{padding: "10px", gap: "30"}}>
                                <FlexView vAlignContent="center"
                                          style={{
                                              gap: 10,
                                              justifyContent: "space-between",
                                              margin: "10px"
                                          }}>
                                    <p>Nota Penjualan</p>
                                    <FlexView style={{justifyContent: "right"}}>
                                        <SimpleButton
                                            text="Preview"
                                            onClick={() => this.handlePrintPreviewVisibility("generate", null)}
                                        />
                                        <SimpleButton
                                            text="Cetak"
                                            onClick={() => this.handlePrint("print", null)}
                                        />
                                    </FlexView>
                                </FlexView>
                                <FlexView vAlignContent="center"
                                          style={{
                                              gap: 10,
                                              justifyContent: "space-between",
                                              margin: "10px"
                                          }}>
                                    <p>Nota Penjualan Klaim SCP</p>
                                    <FlexView style={{justifyContent: "right"}}>
                                        <SimpleButton
                                            text="Preview"
                                            onClick={() => this.handlePrintPreviewVisibility("generate", "SCP")}
                                        />
                                        <SimpleButton
                                            text="Cetak"
                                            onClick={() => this.handlePrint("print", "SCP")}
                                        />
                                    </FlexView>
                                </FlexView>
                            </FlexView>
                        }
                    />
                )}
                {this.state.printPreviewVisible && (
                    <>
                        <SimpleModal
                            title="Print Preview"
                            visible={this.state.printPreviewVisible}
                            onClickClose={() => this.handlePrintPreviewVisibility("close", null)}
                            styles={{
                                width: "100%",
                            }}
                            content={
                                <>
                                    {!R.isNil(this.state.PDF) && (
                                        <iframe
                                            src={this.state.PDF}
                                            style={{border: "none", width: "100%", minHeight: "100vh"}}
                                        ></iframe>
                                    )}
                                    <input
                                        type="file"
                                        accept=".pdf"
                                        onChange={(e) => {
                                            const file = e.target.files[0];
                                            if (file && file.type === "application/pdf") {
                                                const fileReader = new FileReader();
                                                fileReader.onload = () => {
                                                    this.onStateChange({
                                                        PDF: fileReader.result,
                                                    });
                                                };

                                                fileReader.readAsDataURL(file);
                                            }
                                        }}
                                    />
                                </>
                            }
                        />
                        )
                    </>

                )}
                {this.state.alertInfo?.visible && (
                  <SimpleAlert
                    title={this.state.alertInfo?.title}
                    visible={this.state.alertInfo?.visible}
                    onClickClose={() => this.handleVisibleAlertInfo()}
                    content={
                      <p>
                        {this.state.alertInfo?.content}
                      </p>
                    }
                    additionalButtons={
                        <SimpleButton onClick={() => this.handleVisibleAlertInfo()}>
                          Ok
                        </SimpleButton>
                    }
                  />
                )}
                {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
            </>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(null, mapDispatchToProps)(FakturJualNOS);